// 异步加载高德地图
export default function MapLoader() {
    return new Promise((resolve, reject) => {
        if (window.AMap) {
            resolve(window.AMap)
        } else {
            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.async = true;
            script.src = 'https://webapi.amap.com/maps?v=1.3&callback=initAMap&key=55ce8518a39bacd9d41bb37da7e4e129';
            script.onerror = reject;
            document.head.appendChild(script)
        }
        window.initAMap = () => {
            resolve(window.AMap)
        }
    })
}



// WEBPACK FOOTER //
// ./src/components/amap/asyncLoadJs.js